import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE } from './data/content';
import { bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/images';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { BeforeAfter } from './components/BeforeAfter';
import { MeetingSelector } from './components/MeetingSelector';
import { LookInsideSection } from './components/LookInsideSection';
import { SolutionSection } from './components/SolutionSection';
import { OptionsBand } from './components/OptionsBand';
import { YearPlanSection } from './components/YearPlanSection';
import { MeetingsList } from './components/MeetingsList';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = META_PIXEL_ID ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="3diry6xarslch">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="sudlygrs019b" />}
      <TopBar data-id="element-2" data-mp="swq8z8ce51t8" />
      <main data-id="element-3" data-mp="36hw15qrsq0p">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="35ypsmahfq2i" />
        <StatsBand data-id="element-5" data-mp="34x4zq3nzp7l" />
        <BeforeAfter data-id="element-6" data-mp="38b5essrpoce" />
        <MeetingSelector data-id="element-7" data-mp="3ud1ftael3qb5" />
        <LookInsideSection pageImages={pageImages} data-id="element-8" data-mp="3ubrg6gs32a2e" />
        <SolutionSection data-id="element-9" data-mp="3uf5gljh6s977" />
        <OptionsBand data-id="element-10" data-mp="d57f31uekgij" />
        <YearPlanSection data-id="element-11" data-mp="d3mil6oj2ni1" />
        <MeetingsList data-id="element-12" data-mp="d3wax0x1p6qw" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-13" data-mp="85l3sxy4xacd" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-14" data-mp="86w58r43y60b" />
        <GuaranteeSection data-id="element-15" data-mp="3gl4t5lvoq8m5" />
        <FaqSection data-id="element-16" data-mp="3gmfw5jhb3cc7" />
        <FinalCta data-id="element-17" data-mp="3glwbvw46obv0" />
      </main>
      <Footer data-id="element-18" data-mp="3gj1qa19fol00" />
      <StickyCta data-id="element-19" data-mp="3bmjq7ep1tau0" />
    </div>;
}